import React from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

function ForgotPasswordInstructionsCard({ email, resendFunc }) {
  return (
    <Card>
      <CardContent className="login-form-content">
        <Typography className="login-card-header">
          <div className="default-card-header-padding">
            <span className="default-card-header-text">Check your email</span>
          </div>
        </Typography>
      </CardContent>

      <CardContent className="remove">
        <div className="default-card-body-padding">
          <span className="default-card-body-text">
            We sent a password resent link to
          </span>

          <Typography>
            <span className="default-card-header-text">{email}</span>
          </Typography>
        </div>
        <div className="default-card-body-padding">
          <Typography className="remove">
            <span className="default-card-body-text" />
            If you didnt receive the email,
            <Button className="default-card-header-text" onClick={resendFunc}>
              click here to resend
            </Button>
          </Typography>
        </div>
      </CardContent>

      <CardActions className="remove">
        <div className="bottom-padding">
          <span>
            <KeyboardBackspaceIcon />

            <Link to="/" className="loginButtonText">
              Back to Log In
            </Link>
          </span>
        </div>
      </CardActions>
    </Card>
  );
}

ForgotPasswordInstructionsCard.propTypes = {
  email: PropTypes.string.isRequired,
  resendFunc: PropTypes.func.isRequired,
};

export default ForgotPasswordInstructionsCard;
